import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  UpdatePlatformFeeRequestDto,
  UpdatePlatformFeeResponseDto
} from "@/modules/product";
import { ProductService } from "@/modules/product";

type UsePutPlatformFeeMutationParams = {
  options?: UseMutationOptions<
    UpdatePlatformFeeResponseDto,
    unknown,
    UpdatePlatformFeeRequestDto
  >;
};

export const usePutPlatformFeeMutation = ({
  options
}: UsePutPlatformFeeMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.updatePlatformFee({ payload });
    },
    ...options
  });
};
